import { Button } from "PFComponents/button";
import { useShortlistAssign } from "PFCore/hooks/queries/shortlists/use_shortlist_actions";
import { useTranslation } from "react-i18next";

import { useRoleProfileActionButtonsContext } from "../context/role_profile_action_buttons_context";
import { ProfileActionButtonsProps } from "./profile_action_buttons_props";
import css from "./shortlist_buttons.module.scss";

export const InviteButton = ({ onError, onSuccess }: ProfileActionButtonsProps) => {
  const { t } = useTranslation("activities");
  const { role, shortlist, areButtonsDisabled, small } = useRoleProfileActionButtonsContext();
  const { mutate: assignShortlist, isPending } = useShortlistAssign();
  const isAlreadyInvited = shortlist!.state === "assigned";

  const handleClick = () => {
    assignShortlist(shortlist!.id, { onSuccess: () => onSuccess?.("invite"), onError: () => onError?.() });
  };

  const labelText = isAlreadyInvited ? t("show.parts.invited") : t("show.parts.invite");
  const reviewing = role.review && role.review.state !== "complete";
  const isDisabled = areButtonsDisabled || isPending || isAlreadyInvited || reviewing;

  return (
    <Button
      onClick={(event) => {
        event.stopPropagation();
        handleClick();
      }}
      disabled={isDisabled}
      small={small}
      className={css.shortlistButton}
    >
      {!isPending ? labelText : "..."}
    </Button>
  );
};
